import { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import {
    gtmEventType,
    loanApprovalFields,
    approvalAmountLocalStorageName,
    popupListDetailLoanApprovalEstimateModal,
    enableNewRegistrationPopUp
} from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent, getLoanApprovalEstimate } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import Modal from '@Components/Shared/Modals/Modal';
import translator from '@Components/Utilities/Translator';
import LoanApprovalEstimateDisclaimer from '@Components/Shared/LoanApprovalEstimate/LoanApprovalEstimateDisclaimer';
import { setLocalStorageValue } from '@Components/Utilities/CookieHelper';
import ready from 'document-ready';

const LoanApprovalEstimateModal = (props) => {

    const [lae, setLae] = useRecoilState(atoms.lae);
    const [show, setShow] = useRecoilState(atoms.showLae);
    const [submitted, setSubmitted] = useState(false);
    const [estimateFields, setEstimateFields] = useState({
        yearsInBusiness: '',
        creditRange: '',
        priorMaxLoanSize: '',
        assetClass: ''
    });

    useEffect(() => {
        let loanApprovalEstimate = null;
        if (!lae) {
            loanApprovalEstimate = localStorage.getItem(approvalAmountLocalStorageName);
            if (loanApprovalEstimate) {
                setLae(loanApprovalEstimate);
            }
        }

        ready(() => {
            if (enableNewRegistrationPopUp && localStorage.getItem(popupListDetailLoanApprovalEstimateModal) === 'true' && !loanApprovalEstimate) {
                localStorage.removeItem(popupListDetailLoanApprovalEstimateModal);
                document.getElementsByTagName('body')?.[0]?.classList?.add('lock');
                setShow(true);
                gtmPushEvent(gtmEventType.loanApprovalEstimateRegistrationTriggerModal);
            }
        });
    }, []);

    const onSubmit = () => {
        if (estimateFields.yearsInBusiness && estimateFields.creditRange && estimateFields.priorMaxLoanSize && estimateFields.assetClass) {
            let approvalAmount = getLoanApprovalEstimate(estimateFields.yearsInBusiness, estimateFields.creditRange, estimateFields.priorMaxLoanSize, estimateFields.assetClass);
            if (!isNaN(approvalAmount)) {
                if (approvalAmount > 0) {
                    approvalAmount = approvalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    approvalAmount = '$' + approvalAmount + '*';
                } else {
                    approvalAmount = '';
                }

                setLocalStorageValue(approvalAmountLocalStorageName, approvalAmount);
                setLae(approvalAmount);
                setSubmitted(true);
            }
        }
    };

    const onRecalculate = () => {
        setSubmitted(false);
    };

    const onClose = () => {
        document.getElementsByTagName('body')?.[0]?.classList?.remove('lock');
        setShow(false);
    };

    const onChange = (e) => {
        let name = e.target.id, value = e.target.value;
        setEstimateFields((previousState) => {
            return ({ ...previousState, [name]: value });
        });
    };

    return (show &&
        <Modal containerClassName='currency-modal' onEscapeKeyClose={onClose}>
            <Modal.Header displayCloseIconOnly onClose={onClose}>
                <Modal.Title>
                    {translator.translate('sandhills.calculateloanapprovalestimate')}
                </Modal.Title>
                <p>{translator.translate('sandhills.answerthefollowingquestions')}</p>
            </Modal.Header>
            <Modal.Body>
                <p id='description-label' className='hidden'>{translator.translate('sandhills.calculateloanapprovalestimate')}</p>
                <div className='modal-main'>
                    {loanApprovalFields.map(field =>
                        <div key={'Loan Approval ' + field.Id}>
                            <label htmlFor={field.Id}>{field.Label}</label>
                            <select id={field.Id} onChange={onChange} value={estimateFields[field.Id]}>
                                {field.Options.map(item =>
                                    <option key={field.Id + ' ' + item.Label + ' ' + item.Value} value={item.Value}>{item.Label}</option>)}
                            </select>
                        </div>)}
                    <img src={props.LogoUrlBlue} alt='Currency' />
                    {submitted &&
                        <div className='approval-amount'>
                            {lae &&
                                <div id='approval-gt0'>
                                    <strong>{translator.translate('sandhills.yourestimatedloanapproval')}</strong><span className='loan-approval-amount'>{lae}</span><br />
                                </div>}
                            {!lae &&
                                <div id='approval-0'>
                                    {translator.translate('sandhills.couldnotissuepreapproval')} <br />
                                </div>}
                            <div className="modal-buttons">
                                <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); onRecalculate(); } }} className='button currency-recalculate gtm-loan-approval-estimate-modal-recalculate' onClick={onRecalculate}>{translator.translate('sandhills.recalculate')}</a><br />
                                <a className='button gtm-loan-approval-estimate-modal-get-funded' href={props.LenderUrl ?? props.FinancingURL} target='_blank' aria-label={"Apply Now (" + translator.translate('sandhills.opensinanewtab') + ")"}>{translator.translate('sandhills.tradesites.mvc.applynow')}<span className='visually-hidden'>{translator.translate('sandhills.opensinanewtab')}</span></a><br />
                            </div>
                            <LoanApprovalEstimateDisclaimer Disclaimer={props.Disclaimer} />
                        </div>}
                </div>
                {!submitted &&
                    <div className='modal-buttons cf'>
                        <a role='button' tabIndex='0' className='save-modal gtm-loan-approval-estimate-modal-calculate' onClick={onSubmit} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {e.preventDefault(); onSubmit(); } }}>{translator.translate('sandhills.tradepubwebsite.mvc.submit')}</a>
                        <a role='button' tabIndex='0' className='close-modal' onClick={onClose} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {e.preventDefault(); onClose(); } }}>{translator.translate('sandhills.tradepubwebsite.mvc.close')}</a>
                    </div>}
            </Modal.Body>
        </Modal>
    );
};

export default LoanApprovalEstimateModal;